import { useState } from 'react';
import { Link, createFileRoute } from '@tanstack/react-router';
import { useQueries, useQuery } from '@tanstack/react-query';
import { q } from '../../api/queries';
import { ErrorNotice, FreshnessLabel, type Freshness } from '@bounded/ui/state';
import { Button, Page, PageHeader, Panel, Skeleton, Table, col } from '@bounded/ui/primitives';
import { useT } from '../../i18n';
import { PairInstructions } from '../../components/pair-instructions';
import { DaemonVersion } from '../../components/daemon-version';

export const Route = createFileRoute('/_app/devices/')({ component: Devices });

function Devices() {
  const t = useT(); const m = t.devices;
  const devices = useQuery(q.devices());
  const items = devices.data?.items ?? [];
  const runtimes = useQueries({ queries: items.map((d) => q.runtime(d.id)) });
  const [pairing, setPairing] = useState(false);
  // With no devices yet, how to pair one is the whole point of the page; otherwise it opens on request.
  const showPairing = pairing || (!!devices.data && items.length === 0);
  return (
    <Page>
      <PageHeader title={m.title} description={m.description}
        actions={!showPairing && devices.data && <Button variant="primary" onClick={() => setPairing(true)}>{m.pairAction}</Button>} />
      {showPairing && (
        <Panel title={m.pairTitle} actions={items.length > 0 && <Button size="sm" variant="ghost" onClick={() => setPairing(false)}>{t.common.close}</Button>}>
          <div className="grid max-w-3xl gap-1 p-4"><PairInstructions /></div>
        </Panel>
      )}
      {items.length > 0 || devices.isPending || devices.error ? <Panel>
        {devices.isPending && <div className="p-4"><Skeleton className="h-24" /></div>}
        {devices.error && <div className="p-4"><ErrorNotice error={devices.error} onRetry={() => void devices.refetch()} /></div>}
        {items.length > 0 && (
          <Table head={[{ label: m.cols.device }, { label: m.cols.status }, { label: m.cols.agents, className: col.hideMd }, { label: m.cols.version, className: col.hideSm }]} minWidth="0">
            {items.map((d, i) => {
              const r = runtimes[i]?.data;
              return (
                <tr key={d.id} className={d.revoked_at ? 'text-graphite' : undefined}>
                  <td><Link to="/devices/$deviceId" params={{ deviceId: d.id }} className="font-medium hover:underline">{d.name}</Link></td>
                  <td>{r ? <FreshnessLabel freshness={r.connection as Freshness} at={r.received_at} /> : <Skeleton className="h-4 w-24" />}</td>
                  <td className={col.hideMd}>{r?.snapshot ? r.snapshot.adapters.map((a) => t.agents[a.profile] ?? a.id).join(', ') : '—'}</td>
                  <td className={col.hideSm}>{r?.snapshot ? <DaemonVersion version={r.snapshot.daemon_version} /> : '—'}</td>
                </tr>
              );
            })}
          </Table>
        )}
      </Panel> : null}
    </Page>
  );
}
